import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import * as R from 'ramda'
import P from 'helpers/predicates'

import {
  NOTIFICATION,
  UPDATE_TIMEOUT,
  UPDATE_TYPE,
  UPDATE_MESSAGE,
  UPDATE_ACTIVE,
  CLEAR_TYPE,
  CLEAR_MESSAGE,
  CLEAR_ACTIVE,
} from './constants'

const updateNotNil = (prev, now) => P.isNotNil(now)
  ? now
  : prev

const updateTimeout = (prev, { timeout }) => updateNotNil(prev, timeout)
const updateType = (prev, { value }) => updateNotNil(prev, value)
const updateActive = (prev, { active }) => updateNotNil(prev, active)
const updateMessage = (prev, { message }) => updateNotNil(prev, message)

const resetTimeout = () => 3500
const resetType = () => NOTIFICATION.INFO.value
const resetActive = () => false
const resetMessage = () => ''

const timeoutReducer = createReducer(resetTimeout(), {
  [ UPDATE_TIMEOUT ]: updateTimeout,
})

const typeReducer = createReducer(resetType(), {
  [ CLEAR_TYPE ]: resetType,
  [ UPDATE_TYPE ]: updateType,
})

const activeReducer = createReducer(resetActive(), {
  [ CLEAR_ACTIVE ]: resetActive,
  [ UPDATE_ACTIVE ]: updateActive,
})

const messageReducer = createReducer(resetMessage(), {
  [ CLEAR_MESSAGE ]: resetMessage,
  [ UPDATE_MESSAGE ]: updateMessage,
})

export default combineReducers({
  timeout: timeoutReducer,
  type: typeReducer,
  active: activeReducer,
  message: messageReducer
})
